import { createCustomEnum } from "../customEnum";

const ChargebackDecisions = createCustomEnum({
	Complete: {
		value: 0,
		name: "complete",
		displayName: "Complete",
	},
	Terminated: {
		value: 1,
		name: "terminated",
		displayName: "Terminated",
	},
	ReviewNoAction: {
		value: 2,
		name: "review_no_action",
		displayName: "Review no Action",
	},
	RiskMitigated: {
		value: 3,
		name: "risk_mitigated",
		displayName: "Risk Mitigated",
	},
});
export default ChargebackDecisions;
